module.exports = __webpack_public_path__ + "static/media/helpIcon.63df7dcd.svg";